<app-loading-wrapper [loading]="!formTermHasBeenLoaded">
    <app-registrar-admin-maintenance-schedule-form [newCurrentDataSent]="newCurrentDataSent"
                                                   [formTermHasBeenLoaded]="formTermHasBeenLoaded"
                                                   (formTermHasBeenLoadedChange)="sendToListTermInfo($event)"
                                                   (updateScheduleList)="sendToList($event)"></app-registrar-admin-maintenance-schedule-form>
    <app-registrar-admin-maintenance-schedule-batch-process (batchCloseComplete)="updateScheduleList($event)"></app-registrar-admin-maintenance-schedule-batch-process>

    <app-registrar-admin-maintenance-schedule-list (selectGradingSchedule)="sendToEditForm($event)"
                                                   [updateGradingSchedule]="updateGradingSchedule"
                                                   [formTermHasBeenLoaded]="formTermHasBeenLoaded"></app-registrar-admin-maintenance-schedule-list>
</app-loading-wrapper>
